<template>
  <section class="bg-faq py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 text-center mb-5">
          <h1 class="title">{{ $t('message.faqTitle') }}</h1>
          <p>
            {{ $t('message.faqDescription') }}
          </p>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="accordion" id="faqAccordion">
            <div
              v-for="(faq, index) in faqs"
              :key="index"
              class="accordion-item"
            >
              <h2 class="accordion-header" :id="'heading' + index">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapse' + index"
                  aria-expanded="false"
                  :aria-controls="'collapse' + index"
                >
                  {{ faq.question }}
                </button>
              </h2>
              <div
                :id="'collapse' + index"
                class="accordion-collapse collapse"
                :aria-labelledby="'heading' + index"
                data-bs-parent="#faqAccordion"
              >
                <div class="accordion-body" v-html="faq.answer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '@/plugins/i18n'

const faqSlugs = [
  'what-is-ju-financeiro',
  'what-is-trial-period',
  'how-to-subscribe',
  'payment-method',
  'cancel-subscription',
  'forgot-password',
  'data-security',
  'credit-card-storage',
  'multiple-organizations',
  'what-is-financial-organization',
  'trial-features',
]

export default {
  name: 'FaqComponent',
  data() {
    return {
      faqs: [],
    }
  },
  computed: {
    currentLanguage() {
      return i18n.global.locale.value
    },
    faqData() {
      return faqSlugs.map(faqItem => ({
        id: faqItem,
        question: this.$t(`faq.${faqItem}`),
      }))
    },
  },
  watch: {
    currentLanguage() {
      this.loadFaqs()
    },
  },
  async created() {
    this.loadFaqs()
  },
  methods: {
    async loadFaqs() {
      const faqsPromises = this.faqData.map(async faqItem => {
        try {
          const module = await import(
            /* webpackChunkName: "faq-[request]" */
            `@/assets/json/faq/${this.currentLanguage}/${faqItem.id}.md`
          )
          return {
            ...faqItem,
            answer: module.default,
            // A propriedade 'open' não é mais necessária
          }
        } catch (error) {
          console.error('Error loading FAQ item:', error)
          try {
            const module = await import(
              /* webpackChunkName: "faq-[request]" */
              `@/assets/json/faq/${faqItem.id}.md`
            )
            return {
              ...faqItem,
              answer: module.default,
            }
          } catch (fallbackError) {
            console.error('Error loading fallback FAQ item:', fallbackError)
            return {
              ...faqItem,
              answer: 'Error loading content.',
            }
          }
        }
      })
      this.faqs = await Promise.all(faqsPromises)
    },
    // O método toggleFaq não é mais necessário
  },
}
</script>

<style scoped>
/* Estilos gerais para a seção */
.bg-faq {
  /* Padding foi movido para as classes do Bootstrap (py-5) mas pode ser mantido aqui se preferir */
  text-align: center;
}

/* Estilos para os títulos e textos, usando suas variáveis de cor */
.title,
.accordion-button {
  color: var(--c1);
}

.bg-faq p,
.accordion-body {
  color: var(--c3);
}

.accordion-body {
  text-align: left;
  line-height: 1.6;
}

/* Customização opcional do acordeão do Bootstrap para combinar com seu design */
.accordion-item {
  border-color: var(--c2);
  margin-bottom: 10px;
  border-radius: var(--radius-sm) !important; /* !important para sobrescrever o Bootstrap */
  overflow: hidden;
}

.accordion-button:focus {
  box-shadow: none;
  border-color: rgba(0, 0, 0, 0.125);
}

.accordion-button:not(.collapsed) {
  background-color: var(--c2);
  box-shadow: var(--shadow-sm);
  color: var(--c1); /* Mantém a cor do texto quando aberto */
}

.accordion-item {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%232977ff'%3E%3Cpath d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z'/%3E%3C/svg%3E");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%232977ff'%3E%3Cpath d='M1 8a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1z'/%3E%3C/svg%3E");
  --bs-accordion-btn-icon-transform: none;
}

.accordion-button::after {
  width: 1.1rem;
  height: 1.1rem;
  background-size: 1.1rem;
}
</style>
